import * as React from 'react';
import { ButtonType, CustomButton, Table } from 'soprasteria-ui-library';
import { IOrthodonticReferralAdvancedConsultationNeedComment } from '../../../../models/IOrthodonticReferral';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import { useAuth } from '../../../../App';
import { OrthodonticReferralDecisionApi } from '../../../../api/OrthodonticReferralDecisionApi';

interface IOrthodonticReferralAdvancedConsultationNeedCommentTable {
    orthodonticReferralAdvancedConsultationNeedComments: IOrthodonticReferralAdvancedConsultationNeedComment[];
    getOrthodonticReferral: (orthodonticReferralId: number, refresh: boolean) => void;
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeSelectedOrthodonticReferralAdvancedConsultationNeedComment: (comment: IOrthodonticReferralAdvancedConsultationNeedComment) => void;
    orthodonticReferralAdvancedConsultationNeedId: number;
}

interface IDeleteStatus {
    isDeleting: boolean;
    key?: number;
}

export const OrthodonticReferralAdvancedConsultationNeedCommentTable: React.FunctionComponent<IOrthodonticReferralAdvancedConsultationNeedCommentTable> = ({ orthodonticReferralAdvancedConsultationNeedComments, getOrthodonticReferral, orthodonticReferralId, changeSuccessMessage, changeSelectedOrthodonticReferralAdvancedConsultationNeedComment, orthodonticReferralAdvancedConsultationNeedId }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralDecisionApi(auth);
    const [deleteStatus, setDeleteStatus] = React.useState<IDeleteStatus>();

    const showButtonColumn = () => {
        const canEditAnyComment = orthodonticReferralAdvancedConsultationNeedComments.some((comment) => comment.canEdit);
        return canEditAnyComment;
    }

    const deleteComment = (orthodonticReferralAdvancedConsultationNeedCommentId: number, key: number) => {
        setDeleteStatus({ isDeleting: true, key: key });

        api.deleteOrthodonticReferralAdvancedConsultationNeedComment(orthodonticReferralAdvancedConsultationNeedCommentId, orthodonticReferralAdvancedConsultationNeedId, () => {
            changeSuccessMessage("Kommentaren har tagits bort");
            getOrthodonticReferral(orthodonticReferralId, true);
        }, undefined, () => setDeleteStatus({ isDeleting: false }))
    }

    return (
        <Table>
            <thead>
                <tr>
                    <th>Skapad</th>
                    <th>Vårdgivare</th>
                    <th>Mottagning</th>
                    <th>Kommentar</th>
                    {
                        showButtonColumn() ?
                            <th ></th>
                            : null
                    }
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferralAdvancedConsultationNeedComments.length > 0 ?
                        orthodonticReferralAdvancedConsultationNeedComments.map((comment, key) =>
                            <tr key={key}>
                                <td className="text-nowrap">{dateTimeToDateString(comment.regDate)}</td>
                                <td className="text-nowrap">{comment.careProvider.displayOrganisationInformation}</td>
                                <td className="text-nowrap">{comment.careProvider.displayCareProviderName}</td>
                                <td style={{ whiteSpace: "pre-line" }}>{comment.comment}</td>
                                {
                                    showButtonColumn() ?
                                        <td className="text-center text-nowrap">
                                            {
                                                comment.canEdit ?
                                                    <>
                                                        <CustomButton buttonType={ButtonType.general} buttonText="Ändra"
                                                            onClick={() => changeSelectedOrthodonticReferralAdvancedConsultationNeedComment(comment)} />
                                                        <CustomButton buttonType={ButtonType.delete} buttonText=""
                                                            isLoading={deleteStatus?.isDeleting && deleteStatus?.key === key}
                                                            onClick={() => deleteComment(comment.orthodonticReferralAdvancedConsultationNeedCommentId, key)} />
                                                    </>
                                                    : null
                                            }
                                        </td>
                                        : null
                                }
                            </tr>
                        )
                        : <tr><td colSpan={4}>Det finns inga kommentarer</td></tr>
                }
            </tbody>
        </Table>
    )
}